import React from 'react';
import { Segment, Header } from 'semantic-ui-react';

export default (props) => {
    var {title} = props;
    return (
        <Segment style={{padding: 0, margin: 0}} textAlign="center" className="challenge-label-container" basic>
            <Header style={{fontWeight: 100}}>
                {title}
            </Header>
        </Segment>
    )
}


// WEBPACK FOOTER //
// ./src/components/challenges/ChallengeContainerTitle.jsx